import React from 'react';
import {
  TextCustom,
  TextAppearance,
  TextSize,
  TextLineHeight,
  TextWeight,
  Button,
  ButtonAppearance,
  TextAlignment,
  Breakpoints
} from '@vw-marketing/us-components';
import {
  StyledNoReviewsWrapper,
  StyledLabelWrapper,
  StyledResetButtonWrapper
} from './styled';

interface NoReviewsProps {
  onReset: () => void;
}
const NoReviews: React.FC<NoReviewsProps> = props => {
  const {onReset} = props;

  //Component Constants
  const noReviewsLabel = 'Sorry, there are no reviews available.';
  const buttonLabel = 'Reset filters';

  return (
    <StyledNoReviewsWrapper>
      <StyledLabelWrapper>
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize24,
              lineHeight: TextLineHeight.TextLineHeight32,
              fontWeight: TextWeight.bold,
              textAlign: TextAlignment.center
            },
            [Breakpoints.b960]: {lineHeight: TextLineHeight.TextLineHeight22}
          }}
        >
          {noReviewsLabel}
        </TextCustom>
      </StyledLabelWrapper>
      <StyledResetButtonWrapper>
        <Button appearance={ButtonAppearance.Primary} onClick={onReset}>
          {buttonLabel}
        </Button>
      </StyledResetButtonWrapper>
    </StyledNoReviewsWrapper>
  );
};

export default NoReviews;
